import { ZOLL_ONLINE } from '@/constants';
import { container } from '@/container';
import { Connection } from '@/services/Connection';
import { RouterGuard } from '@/services/router/types';

/**
 * Redirect if CAD is not yet initialized.
 */
export const helpGuard: RouterGuard = async function helpGuard(to, from, next) {
  const connection = await container.getAsync(Connection);
  if (to.name === 'help') {
    let helpUrl = '';
    if (connection.isHybrid) {
      helpUrl = ZOLL_ONLINE.HYBRID_HELP_URL;
    }
    else if (connection.isStandalone) {
      helpUrl = ZOLL_ONLINE.HELP_URL;
    }
    else if (connection.isPortal) {
      helpUrl = ZOLL_ONLINE.PORTAL_HELP_URL;
    }
    window.location.replace(helpUrl);
    next();
  }
  else {
    next();
  }
};
